import {PdsAbstractInputWidget} from './pds-abstract-input-widget';
import {BasicValidationRules, Time} from 'common-utils/interfaces';
import { pdsValidationRulesEngine } from './pds-validation-rules-engine';
import { pdsI18n } from './pds-i18n';
import { SimpleTime } from 'common-utils';

let isIntegerRegex = /^([-]?[0-9]*)?$/;

export class PdsTimeWidget extends PdsAbstractInputWidget {
  is = 'pds-time-widget';

  //Validation Properties
  dataMaxtime: string;
  dataMintime: string;

  properties = {
    //AbstractInputWidget Properties
    name: String, //We construct the id using the name property
    dataLabelText: String,
    dataShowLabel: {
      type: String,
      value: null
    },
    dataBadgeText: {
      type: String,
      value: '',
      observer: 'setUpBadge'
    },
    dataHelperText: {
      type: String,
      value: null
    },
    dataFieldHelpText: String,
    dataPlaceholderText: String,
    dataTooltipText: String,
    dataUseAlternateColorScheme: {
      type: String,
      value: 'false'
    },
    dataIsreadonly: {
      type: String,
      value: 'false',
      observer: 'setReadonlyText'
    },
    dataIsfieldonly: {
      //This is for adding a class to get rid of the bottom padding.
      type: String,
      value: 'false'
    },
    dataHideUnelevatedBadge: {
      type: String,
      value: 'false',
      observer: 'setUpBadge'
    },
    dataDisableInvalidBadgeElevation: {
      type: String,
      value: 'false',
      observer: 'setUpBadge'
    },
    //Widget specific Validation Properties
    dataIsrequired: {
      type: String,
      value: 'false',
      observer: 'setUpBadge'
    },
    disabled: {
      type: String,
      value: 'false'
    },
    //Option to activate the validation indicator
    dataUseValidIndicator: {
      type: String,
      value: 'false'
    },
    dataMaxtime: String,
    dataMintime: String,
    dataCustomvalidate: String,
    dataActionIcon: String
  };

  generateValidationRules(): void {
    let validationRules: BasicValidationRules = pdsValidationRulesEngine.getBasicValidationRules();
    validationRules.isTime = true;
    validationRules.setProperty('isRequired', this.dataIsrequired, Boolean);
    validationRules.setProperty('minValue', this.dataMintime, SimpleTime);
    validationRules.setProperty('maxValue', this.dataMaxtime, SimpleTime);

    this.validators = pdsValidationRulesEngine.getValidatorsForRules(validationRules);

    if (this.hasOwnProperty('dataCustomvalidate')) {
      this.validators.push({
        execute: this.pds.validation.getCustomValidate(this.dataCustomvalidate),
        condition: {
          element: this
        }
      });
    }
  }

  /**
   * @param modelValue
   * @param skip
   * @returns returns if the model value was actually set.
   */
  setModelValue(modelValue: Time, skip: boolean): boolean {

    let ele = this.querySelector('input');
    if (ele != null && modelValue !== ele.modelValue) {
      ele.modelValue = modelValue;
      if (skip !== true) {
        this.setValue(pdsI18n.localizeTime(modelValue), true);
      }
      return true;
    }
    return false;
  }

  /**
   *
   * @param value - The string the user typed into the input.
   * @param skip - skips setting the model value. (Keeps from getting into recursive loops)
   */
  setValue(value: string, skip = false): void {
    if (value == null) {
      value = '';
    }

    let inputEl = this.querySelector('input');
    if (inputEl != null && value !== inputEl.value) {
      inputEl.value = value;
    }

    if (skip !== true) {
      this.setModelValue(pdsI18n.deLocalizeTime(value), true);
    }
  }
}
